import { useQuery } from "@tanstack/vue-query";
import { getOrganization, type Customer } from "../services/user";
import { computed } from "vue";
import { getUserEmail } from "../config/firebase.ts";

export function useOrganization() {
    const {
        data: organization,
        isLoading: loadingOrganization,
        error: organizationError,
        isError: isOrganizationError,
        refetch: reloadOrganization,
    } = useQuery<Customer>({
        queryKey: ["user", "organization"],
        queryFn: getOrganization,
    });

    const contactEmailToName = (email: string): string => {
        if (!organization.value?.contacts) return email;

        const contact = organization.value.contacts.find((contact) => contact.email === email);
        return contact?.name || email;
    };

    /**
     * Returns the name of the current user based on their email from contacts.
     * Avoids returning the Firebase name which may be not the one set in Admin Tools's contact section,
     */
    const userNameFromContacts = computed(() => contactEmailToName(getUserEmail() || ""));

    return {
        organization,
        loadingOrganization,
        organizationError,
        isOrganizationError,
        reloadOrganization,
        contactEmailToName,
        userNameFromContacts,
    };
}
